export enum ActionTypes {
  RemoveExpertInsightsRequest = 'removeExpertInsights.request',
  RemoveExpertInsightsSuccess = 'removeExpertInsights.success',
  RemoveExpertInsightsFailure = 'removeExpertInsights.failure',
}
